import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AuthState } from "./auth.model";

const selectState = createFeatureSelector<AuthState>('authState');

export const selectAuthState = createSelector(
  selectState,
  (state: AuthState) => state
)

export const selectDigitalProfileID = createSelector(
  selectState,
  (state: AuthState) => state.digitalProfileId
)

export const selectFirebaseAuthToken = createSelector(
  selectState,
  (state: AuthState) => state.firebaseAuthToken
)

export const selectRisk = createSelector(
  selectState,
  (state: AuthState) => state.risk
)